import React from 'react'
import PropTypes from 'prop-types'
import Mask from 'vanilla-masker'
import classNames from 'classnames'

const InputHour = (props) => {
  const {
    id,
    type = 'text',
    name,
    value,
    onChange,
    onKeyPress = () => {},
    onKeyDown = () => {},
    onKeyUp = () => {},
    onBlur,
    label,
    checked,
    disabled = false,
    minLength,
    maxLength,
    min,
    max,
    className,
    placeholder,
    separator = ':',
    integer = false,
    bottomLabel,
    clearable,
  } = props

  const handleChange = (event) => {
    const str = event.target.value.replace(/[^\d]+/g, '')

    if (!integer) {
      let mask

      switch (str.length) {
        case 3:
          mask = `9${separator}99`
          break
        case 4:
          mask = `99${separator}99`
          break
        case 5:
          mask = `9${separator}99${separator}99`
          break
        case 6:
          mask = `99${separator}99${separator}99`
          break
        case 7:
          mask = `9${separator}99${separator}99${separator}99`
          break
        case 8:
          mask = `99${separator}99${separator}99${separator}99`
          break
        default:
          mask = `99${separator}99${separator}99${separator}99`
          break
      }

      event.target.value = Mask.toPattern(event.target.value, mask)
    } else {
      event.target.value = str
    }

    onChange(event)
  }

  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(event)
    }
  }

  const handleKeyPress = (event) => {
    if (onKeyPress) {
      onKeyPress(event)
    }
  }

  const handleKeyDown = (event) => {
    if (onKeyDown) {
      onKeyDown(event)
    }
  }

  const handleKeyUp = (event) => {
    if (onKeyUp) {
      onKeyUp(event)
    }
  }

  const inputClass = classNames({
    input: type !== 'radio' && type !== 'checkbox',
  })
  return (
    <span>
      <input
        type={type}
        name={name}
        id={id}
        className={`${inputClass} ${className}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        checked={checked}
        disabled={disabled}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        placeholder={placeholder}
      />

      {label && (
        <label htmlFor={id} className='label'>
          {label}
        </label>
      )}

      {clearable && value && (
        <strong
          className='clearable-input-text'
          onClick={() => onChange({ target: { value: '' } })}
        >
          &times;
        </strong>
      )}

      {bottomLabel && <i className='bottomLabel'>{bottomLabel}</i>}
    </span>
  )
}

InputHour.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  separator: PropTypes.string,
  delimiter: PropTypes.string,
  integer: PropTypes.bool,
  bottomLabel: PropTypes.string,
  clearable: PropTypes.bool,
}

export default InputHour
